'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';
import { elevarBaseData } from '@/lib/elevar/cart-events';
import { useCart } from '../commerce/cart/cart-context';

export default function ElevarBaseData() {
  const { cart, cartReady } = useCart();
  const pathname = usePathname();
  const lastFiredPath = useRef(null);

  useEffect(() => {
    if (!cartReady || lastFiredPath.current === pathname) return;
    lastFiredPath.current = pathname;
    (async () => {
      if (window.ElevarDataLayer?.length > 1) {
        await window.ElevarInvalidateContext?.();
      }
      await elevarBaseData(cart);
    })();
  }, [cartReady, cart, pathname]);

  useEffect(() => {
    return () => {
      lastFiredPath.current = null;
    };
  }, [pathname]);

  return null;
}
